// extracted by mini-css-extract-plugin
export default {"wrapper":"error_wrapper__bvIqD","opacity-transition":"error_opacity-transition__GmUH4"};